import {useDispatch, useSelector} from 'react-redux'
import {useError, useResolver, useTest, useUserId} from '@enisco/mcc-react-lib'
import {setProfile} from '../store/appsSlice'
import {Profile} from '../model/profiles'
import {AppRootState} from '../model/config'

const mockedData = {
  _id: '123456'
}

const useProfile = (): [
  Profile | undefined,
  (newValue: Partial<Profile>) => void
] => {
  const dispatch = useDispatch()
  const resolver = useResolver()
  const test = useTest()
  const userId = useUserId()
  const error = useError()
  const profile = useSelector((state: AppRootState) => state.app.profile)
  const setter = (newValue: Partial<Profile>) => {
    if (userId) {
      resolver(
        'mcc-portal-api',
        '/internal/user-profiles' + (profile?.id ? '/' + profile?.id : ''),
        {
          options: {
            method: profile?.id ? 'PUT' : 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
              ...profile,
              ...newValue
            } as Profile)
          },
          mockedResponse: test ? JSON.stringify(mockedData) : undefined
        }
      )
        .then((response: {json: () => any}) => response.json())
        .then((data: {ID: string}) => {
          dispatch(
            setProfile({
              ...profile,
              ...newValue,
              id: data.ID
            })
          )
        })
        .catch(error)
    }
  }
  return [profile, setter]
}

export default useProfile
